import { BuilderType, projectsCacheTags } from './projectsApiHelpers';

export type ChannelType = {
  id: number;
  name: string;
  description?: string;
  client_id?: number;
  placement_strategy: 'direct' | 'container';
  can_materialize: boolean;
};

export const channelTypesApi = (builder: BuilderType) => ({
  getChannelTypes: builder.query<ChannelType[], void>({
    query: () => `service/channel-types`,
    providesTags: [projectsCacheTags.CHANNEL_TYPES],
  }),

  createChannelType: builder.mutation<ChannelType, any>({
    query: (owner) => ({
      url: `service/channel-types`,
      method: 'POST',
      body: owner,
    }),
    invalidatesTags: [projectsCacheTags.CHANNEL_TYPES],
  }),

  updateChannelType: builder.mutation<ChannelType, any>({
    query: (owner) => ({
      url: `service/channel-types/${owner.id}`,
      method: 'PUT',
      body: owner,
    }),
    invalidatesTags: [projectsCacheTags.CHANNEL_TYPES],
  }),

  deleteChannelType: builder.mutation<ChannelType, number>({
    query: (id) => ({
      url: `service/channel-types/${id}`,
      method: 'DELETE',
    }),
    invalidatesTags: [projectsCacheTags.CHANNEL_TYPES],
  }),
});
